import React, { memo } from 'react';
export const MemorabiliaBanner = () => {
  return <section id="memorabilia" className="relative w-full min-h-[400px] md:min-h-[500px] flex items-center justify-center overflow-hidden bg-ink" data-id="element-108">
      {/* Parallax Background */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat bg-fixed" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1566577739112-5180d4bf9390?q=80&w=2800&auto=format&fit=crop")'
    }} data-id="element-109" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-ink/80" data-id="element-110" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center py-16" data-id="element-111">
        <h2 className="font-heading text-3xl md:text-5xl text-white mb-6 uppercase tracking-wide max-w-3xl leading-tight" data-id="element-112">
          Own a Piece of History
        </h2>
        <p className="text-lg text-cream mb-8 max-w-2xl" data-id="element-113">
          Explore our premium collection of game-used gear, signed full-size
          helmets, and exclusive Ohio State memorabilia.
        </p>
        <a href="#memorabilia" className="bg-scarlet text-white font-bold uppercase tracking-wider px-8 py-4 rounded-lg hover:bg-scarlet/90 transition-colors text-center min-h-[48px] flex items-center justify-center w-full sm:w-auto" data-id="element-114">
          View Memorabilia
        </a>
      </div>
    </section>;
};